var stickyHeader = function stickyHeader() {
  var header = document.querySelector(".header");
  if (!header) {
    return;
  }
  var topbar = document.querySelector(".header-top-bar").getBoundingClientRect();
  window.onscroll = function () {
    if (window.scrollY > topbar.height) {
      document.body.classList.add("padding-for-header");
      header.classList.add("sticky");
    } else {
      document.body.classList.remove("padding-for-header");
      header.classList.remove("sticky");
    }
  };
};
export { stickyHeader };